import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
	 userinfor:{},
	 token:''
  },
  getters: {
	  gettoken(state){
		  return state.token
	  }
  },
  mutations: {
	  setuserinfor(state, payload) {
	    state.userinfor = payload
	  },
	  settoken(state, token) {
		console.log('settoken',token)
	    state.token = token
	  }
  },
  actions: {
  },
  modules: {
  }
})
